import authReducer from "./authReducer";
import { combineReducers } from "redux";
import { firebaseReducer } from "react-redux-firebase";
import athleteReducer from "./athleteReducer";
import { firestoreReducer } from "redux-firestore";
import newSignUpReducer from "./newSignUpReducer";
import wikiReducer from "./wikiReducer";
import partnersReducer from "./partnersReducer";
import stwReducer from "./schoolstowatchReducer";
import testimonialReducer from "./testimonialReducer";
import mediaReducer from "./mediaReducer";
import statReducer from "./statsPhotosReducer";
import slideshowPhotoReducer from "./slideshowReducer";
import remindersReducer from "./remindersReducer";
const rootReducer = combineReducers({
  auth: authReducer,
  athlete: athleteReducer,
  signup: newSignUpReducer,
  firestore: firestoreReducer,
  firebase: firebaseReducer,
  wiki: wikiReducer,
  partners: partnersReducer,
  schoolstowatch: stwReducer,
  testimonial: testimonialReducer,
  media: mediaReducer,
  statsPhotos: statReducer,
  slideshowPhoto: slideshowPhotoReducer,
  reminder: remindersReducer,
});

export default rootReducer;
